import { AxiosRequestConfig } from 'axios'

import { transformAuthUserJsonResponse } from 'utils/authLoginResponse'

const tokenLogin = (): AxiosRequestConfig => ({
  url: `/auth/login/token`,
  method: 'POST',
  transformResponse: [transformAuthUserJsonResponse],
})

export { tokenLogin }
